import React from 'react';
import { Layers, Minus, Plus } from 'lucide-react';
import NumericInput from './NumericInput';

const BulkAddModal = ({
  showBulkAddModal,
  setShowBulkAddModal,
  bulkScreenCount,
  setBulkScreenCount,
  screensLength,
  addBulkScreens
}) => {
  if (!showBulkAddModal) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl dark:shadow-gray-900/20 max-w-md w-full border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-5">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-primary-100 rounded-xl">
              <Layers className="w-5 h-5 text-primary-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-800">Add Multiple Screens</h2>
          </div>
        </div>
        
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4">
            Quickly add multiple blank screens to your assessment at once.
          </p>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Number of screens to add
            </label>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setBulkScreenCount(Math.max(1, bulkScreenCount - 1))}
                className="w-10 h-10 flex items-center justify-center text-gray-600 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
              >
                <Minus className="w-4 h-4" />
              </button>
              
              <NumericInput
                min={1}
                max={50}
                value={bulkScreenCount}
                fallback={1}
                onChange={(val) => setBulkScreenCount(val)}
                className="flex-1 px-4 py-2 text-center text-lg font-semibold border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
              
              <button
                onClick={() => setBulkScreenCount(Math.min(50, bulkScreenCount + 1))}
                className="w-10 h-10 flex items-center justify-center text-gray-600 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
              >
                <Plus className="w-4 h-4" />
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">Maximum: 50 screens</p>
          </div>

          <div className="mt-4 p-3 bg-primary-50 border border-primary-200 rounded-lg">
            <p className="text-xs text-primary-700">
              <strong>Preview:</strong> Will create{' '}
              <strong className="text-primary-800">
                Screen {screensLength + 1} - Screen {screensLength + bulkScreenCount}
              </strong>
            </p>
          </div>
        </div>

        <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end space-x-3">
          <button
            onClick={() => {
              setShowBulkAddModal(false);
              setBulkScreenCount(5);
            }}
            className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white dark:bg-gray-800 border border-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={() => addBulkScreens(bulkScreenCount)}
            className="px-5 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-xl hover:bg-primary-700 flex items-center shadow-sm dark:shadow-gray-900/20 hover:shadow transition-all"
          >
            <Layers className="w-4 h-4 mr-2" />
            Add {bulkScreenCount} Screen{bulkScreenCount !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkAddModal;
